module.exports = __webpack_public_path__ + "static/img/robot.cdcfc6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot.png
// module id = dL/P
// module chunks = 21